import {RootState} from "../../../store/reducer/root/RootState";
import Tag from "../../../model/tag/Tag";
import {connect} from "react-redux";
import SearchDropdownFilter from "./SearchDropdownFilter";

class LeadTagFilter extends SearchDropdownFilter<Tag> {

	itemToId(item: Tag): string {
		return item.name;
	}

	itemToLabel(item: Tag): string {
		return item.name;
	}
}

function mapStateToProps(state: RootState,) {
	return {
		items: state.lead.tags
	}
}

export default connect(mapStateToProps)(LeadTagFilter)